
<template>
  <div class="pagamento">
    <b-container fluid>
      <div v-if="showBonifico" class="bonifico col-sm-6 offset-sm-3">

        <h5 class="mb-3"><b>La richiesta di abbonamento è stata inviata.</b></h5><br />
        Ricorda di effettuare il pagamento tramite bonifico bancario sul conto corrente indicato di seguito e di trasmettere copia del versamento all'email <b><a href="mailto:admin@giustup.it">admin@giustup.it</a></b> o tramite fax al numero <b>055.56.09.352</b>. In seguito verrai abilitato il prima possibile e la fattura ti sarà inviata per email entro 24 ore.<br />
        <br /><br />
        <b>Importo da versare: € 122 IVA Compresa</b><br /><br />
        <b>PressLex della Dott.ssa Chiara Morocchi</b><br />
        <b>Banca del Valdarno</b><br />
        Filiale di Castelfranco e Pian di Scò (AR)<br />
        IBAN: IT71O0881105453000000303325

      </div>
      <div v-if="showPaypal" class="paypal col-sm-6 offset-sm-3">
        <h5>Abbonati per un anno al costo di 100€ + IVA</h5>
        <form action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_top" class="mt-5"> 
          <input type="hidden" name="business" value="presslex.editrice@gmail.com"> 
          <input type="hidden" name="cmd" value="_xclick">
          <input type="hidden" name="item_name" value="Abbonamento annuale giustup.it"> 
          <input type="hidden" name="amount" value="122.00"> 
          <input type="hidden" name="currency_code" value="EUR">
            <input type="image" src="https://www.paypalobjects.com/it_IT/IT/i/btn/btn_buynowCC_LG.gif" border="0" name="submit" alt="PayPal è il metodo rapido e sicuro per pagare e farsi pagare online.">
            <img alt="" border="0" src="https://www.paypalobjects.com/it_IT/i/scr/pixel.gif" width="1" height="1">
        </form>
      </div>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'InfoPagamento',
  data () {
    return {
      showBonifico: this.$route.params.tipopagamento == 'bonifico',
      showPaypal: this.$route.params.tipopagamento == 'paypal'
    }
  },
  mounted() {
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Pagamento/InfoPagamento.vue